import React, { useEffect } from "react";
// import NutrientReportService from "../../services/nutrientReport.service";
import { FylloHeader, FylloNutrientReports } from "react-library";
import "./nutrientReportHistory.css";
import { TBackEvent } from "../../types";
import { 
  useNavigate, 
  useParams } from "react-router-dom";
import { Routes } from "../../routes";
import { t } from "../../services/locale.service";

const NutrientReportHistory:React.FC = ()=>{
  const navigate = useNavigate();
  const { plotId } = useParams();

  const headerTitle = t("fertigation") + " " + t("History");

  useEffect(()=>{
    fetchReports();
  },[]);

  useEffect(() => {
    window.addEventListener("nutrientReportClicked", handleNutrientReportClick);
    window.addEventListener("back-icon-press", handleBack);
    return () => {
      window.removeEventListener("nutrientReportClicked", handleNutrientReportClick);
      window.removeEventListener("back-icon-press", handleBack);
    };
  }, []);

  const handleNutrientReportClick = (e: Event) => {
    const event = e as TBackEvent;
    const eventKey = event.detail;
    if(Object.keys(event.detail).length>0){
      navigate(Routes.viewFertigationReport.replace(":plotId", plotId!), { state: { report: eventKey } });
    }
  };

  const handleBack = (e: Event) => {
    const event = e as TBackEvent;
    const eventKey = event.detail;
    if(eventKey === headerTitle) {
      navigate(Routes.fertigation.replace(":plotId", plotId!));
    }
  };

  const fetchReports = async ()=>{
    // const nutrientReports = await NutrientReportService.getPlotNutrientReports(plotId!);
    // either we can pass plot it or this nutrientReports array
  };

  return (
    <div>
      <FylloHeader headerTitle={headerTitle} hasBackIcon />
      <div className="nutrient-reports">
        <FylloNutrientReports class="nutrient-report-cards" plot-id={plotId} />
      </div>
    </div>
  );
};

export default NutrientReportHistory;